"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingEventType = void 0;
var VestingEventType;
(function (VestingEventType) {
    VestingEventType["EtherReleased"] = "EtherReleased";
    VestingEventType["ERC20Released"] = "ERC20Released";
    VestingEventType["PaymentReceived"] = "PaymentReceived";
})(VestingEventType || (exports.VestingEventType = VestingEventType = {}));
//# sourceMappingURL=vesting.js.map